import React, { useContext, useEffect } from 'react'

import Breadcrumb from 'components/common/molecules/Breadcrumb'

import KoinworksBanner from './KoinworksBanner'
import KoinworksIntroduction from './KoinworksIntroduction'
import KoinworksWhy from './KoinworksWhy'
import KoinworksCriteria from './KoinworksCriteria'
import KoinworksTestimony from './KoinworksTestimony/KoinworksTestimony'
import KoinworksFAQ from './KoinworksFAQ'
import KoinworksStep from './KoinworksStep'
import KoinworksWidget from './KoinworksWidget'
import KoinworksTable from './KoinworksTable'
import { PageCtx, ActionType } from 'components/utils/PageProvider'

const KoinworksLP = () => {
  const { dispatch } = useContext(PageCtx)
  const stickyContent = {
    title: 'Pilih Universitas impian, bayar biaya dengan cicilan',
    buttonText: 'Ajukan Sekarang',
    link: 'https://forms.gle/L6Md7JMe5xqCexSGA',
    firstSection: '.koinworks-banner',
  }
  const navbarContent = {
    title: 'Koinworks',
  }

  useEffect(() => {
    dispatch({
      type: ActionType.SET_CUSTOM_NAVBAR,
      payload: { navbarContent },
    })
    dispatch({
      type: ActionType.SET_STICKY_PROPS,
      payload: { stickyContent },
    })
  }, [])
  const KoinworksLPPath = [
    {
      name: 'Mitra',
      url: '/partners',
    },
    {
      name: 'KoinWorks',
      url: '#',
    },
  ]
  return (
    <div className="koinworks">
      <Breadcrumb paths={KoinworksLPPath} />
      <KoinworksBanner />
      <KoinworksIntroduction />
      <KoinworksWhy />
      <KoinworksStep />
      <KoinworksCriteria />
      <KoinworksTable />
      <KoinworksTestimony />
      <KoinworksFAQ />
      <KoinworksWidget />
    </div>
  )
}

export default KoinworksLP
